import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { useApiAccess } from "./useApiAccess";
import { getCategory } from "../../Service/CategoryService";
import { queryKeys } from "./queryKeys";

export function useAllCategories() {
  const hasAccess = useApiAccess();
  const [searchParams] = useSearchParams();
  const productParam = searchParams.get("product");

  const pathParams = { ...(productParam && { product: productParam }) };

  return useQuery(
    queryKeys.allCategories(productParam),
    () => getCategory(pathParams),
    { enabled: !!hasAccess }
  );
}
